import GradeFilter, {
  GradeFilterProps,
} from '@/catalog/components/CatalogSidebar/CatalogFilters/FiltersPanel/GradeFilter/GradeFilter';
import Filters from '@/catalog/entity/Filters';
import { formatGradeValue } from '@/catalog/helpers/formatGradeValue';
import { FilterInputMeta } from '@/catalog/types/filterInputMeta';

type FilterConfig = Required<Pick<FilterInputMeta, 'id' | 'name' | 'getter' | 'setter'>> &
  Pick<FilterInputMeta, 'showTitle'> & { marks?: string[] };

export function gradeFilterFactory(config: FilterConfig): FilterInputMeta {
  return {
    id: config.id,
    name: config.name,
    dict: null,
    range: [0, 1],
    component: (props: GradeFilterProps) => <GradeFilter {...props} marks={config.marks} />,
    setter: config.setter,
    getter: config.getter,
    getStringValue(filters: Filters) {
      return formatGradeValue(config.getter(filters), config.marks);
    },
    reset(filters: Filters) {
      config.setter({ from: null, to: null }, filters);
    },
    isEmpty(filters: Filters) {
      const value = config.getter(filters);

      return Boolean(!value.from && !value.to);
    },
    step: 0.05,
    tickInterval: 0.25,
    nullable: true,
    showTitle: !!config.showTitle,
  };
}
